import React, { Component } from 'react'
import { Container, Col, Row } from 'reactstrap'
import { T } from '../traks'
import { A } from '../routes'
import { site_name } from '../Site'
import OurLogo from '../c/OurLogo'
import OurAdSense from '../c/OurAdSense.js'
import { using_cookiebot } from '../c/Cookiebot.js'

class Footer extends Component {
  render() {
    const our_logo = <OurLogo />

    let ad_sense_stuff = null
    let insta_link, fb_link, linkedin_link
    let footer_imprint_title = <T>Contact us</T>

    if (IS_AKTIEDYSTEN_DK) {
      insta_link = 'https://www.instagram.com/aktiedysten'
      fb_link = 'https://www.facebook.com/aktiedysten'
      linkedin_link = 'https://www.linkedin.com/company/12662458'
    } else if (IS_AKTIEKAMPEN_SE) {
      insta_link = 'https://www.instagram.com/aktiekampen_se'
      fb_link = 'https://www.facebook.com/aktiekampen'
    } else if (IS_INVESTSPIEL_DE) {
      insta_link = 'https://www.instagram.com/investspiel_de'
      fb_link = 'https://www.facebook.com/investspiel'
      footer_imprint_title = <T>Imprint / Contact</T>
    } else if (IS_TRADERR_COM) {
      insta_link = 'https://www.instagram.com/traderr_investing/'
      fb_link = 'https://www.facebook.com/TraderrFantasyInvesting'
    }

    if (IS_INVESTSPIEL_DE) {
      ad_sense_stuff = (
        <Container>
          <Row className="pb-4">
            <Col xs="12">
              <div className="text-center">
                <OurAdSense dataAdSlot="5609577450" />
              </div>
            </Col>
          </Row>
        </Container>
      )
    }

    const ImgUrlsSOME = (props) => (
      <React.Fragment>
        <div className="pt-4 ad_pr_11px">
          <a alt="Facebook" href={fb_link} rel="noopener noreferrer" target="_blank">
            <img alt="" src="https://static.aktiedysten.dk/gfx/logo-facebook-footer-2023-0.svg" />
          </a>
        </div>
        {insta_link && (
          <div className="ad_pr_11px pt-4">
            <a alt="Instagram" href={insta_link} rel="noopener noreferrer" target="_blank">
              <img alt="" src="https://static.aktiedysten.dk/gfx/logo-instagram-footer-2023-0.svg" />
            </a>
          </div>
        )}
        {linkedin_link && (
          <div className="ad_pr_11px pt-4">
            <a alt="LinkedIn" href={linkedin_link} rel="noopener noreferrer" target="_blank">
              <img alt="" src="https://static.aktiedysten.dk/gfx/logo-linkedin-footer-2023-0.svg" />
            </a>
          </div>
        )}
      </React.Fragment>
    )

    return (
      <React.Fragment>
        {ad_sense_stuff}
        <Container fluid className="navbar-dark">
          <Container>
            <Row>
              <Col>
                <Row className="pt-3">
                  <Col xs="12" md="2" className="text-left text-md-right">
                    <div className="ad_pt_2px">{our_logo}</div>
                    <div className="d-flex flex-md-row-reverse">
                      <ImgUrlsSOME />
                    </div>
                    {!IS_TRADERR_COM && (
                      <div className="py-3">
                        <a className="ad_footer_link" target="_blank" rel="noopener noreferrer" href="https://www.edtecheurope.org/">
                          <img src="https://static.aktiedysten.dk/gfx/eea-logo-footer-0.png" alt="EEA logo" width="125" />
                        </a>
                      </div>
                    )}
                  </Col>
                  <Col xs="12" md="3" className="pl-md-5 pb-4">
                    <div className="font-small ad_footer_header pt-2 pl-md-4">{site_name}</div>
                    <div className="font-small pt-3 pl-md-4">
                      <T>
                      <A className="ad_footer_link" href="/about">
                        <T>About Aktiedysten</T>
                      </A>
                      </T>
                    </div>
                    <div className="font-small pt-3 pl-md-4">
                      <A className="ad_footer_link" href="/privacy">
                        <T>Privacy policy</T>
                      </A>
                    </div>
                    {using_cookiebot() && (
                      <div className="font-small pt-3 pl-md-4">
                        <A className="ad_footer_link" href="/cookies">
                          <T>About cookies</T>
                        </A>
                      </div>
                    )}
                    <div className="font-small pt-3 pl-md-4">
                      <A className="ad_footer_link" href="/termsofuse">
                        <T>Terms of use</T>
                      </A>
                    </div>

                    {(IS_AKTIEDYSTEN_DK || IS_AKTIEKAMPEN_SE) && (
                      <React.Fragment>
                        <div className="font-small pt-3 pl-md-4">
                          <T>
                            <a className="ad_footer_link" href="https://undervisning.aktiedysten.dk/gdpr/">
                              GDPR
                            </a>
                          </T>
                        </div>
                      </React.Fragment>
                    )}
                    <div className="font-small pt-3 pl-md-4">
                        <T>
                            <a className="ad_footer_link" href="https://undervisning.aktiedysten.dk/kontakt-os/">
                                {footer_imprint_title}
                            </a>
                        </T>
                    </div>
                  </Col>
                  {(IS_AKTIEDYSTEN_DK || IS_AKTIEKAMPEN_SE || IS_INVESTSPIEL_DE) && (
                    <React.Fragment>
                        {(IS_AKTIEDYSTEN_DK || IS_AKTIEKAMPEN_SE) && (
                            <Col xs="12" md="3" className="pl-md-4 pb-4">
                                <div className="font-small ad_footer_header pt-2">
                                <T>Learn with {site_name}</T>
                                </div>
                                
                                <div className="font-small pt-3">
                                    <T>
                                    <a className="ad_footer_link" target="_blank" rel="noopener noreferrer" href="https://inspiration.aktiedysten.dk/">
                                        Inspiration
                                    </a>
                                    </T>
                                </div>
                                

                                <div className="font-small pt-3">
                                <T>
                                    <a className="ad_footer_link" target="_blank" rel="noopener noreferrer" href="https://undervisning.aktiedysten.dk/">
                                    Education
                                    </a>
                                </T>
                                </div>
                            </Col>
                      )}

                      <Col xs="12" md="3" className="pl-md-4 pb-4">
                        <div className="font-small ad_footer_header pt-2">
                          <T>Prices & Plans</T>
                        </div>
                        <div className="font-small pt-3">
                          <T>
                            <a className="ad_footer_link" target="_blank" rel="noopener noreferrer" href="https://undervisning.aktiedysten.dk/premium-undervisning/">
                              Education
                            </a>
                          </T>
                        </div>
                        <div className='font-small pt-3'>
                          <T>
                            <a className='ad_footer_link' target="_blank" rel="noopener noreferrer" href="https://undervisning.aktiedysten.dk/premium-store-spil/">
                              Large Games (+100)
                            </a>
                          </T>
                        </div>
                        <div className='font-small pt-3'>
                          <T>
                            <a className='ad_footer_link' target="_blank" rel="noopener noreferrer" href="https://undervisning.aktiedysten.dk/premium-erhverv/">
                              For Businesses
                            </a>
                          </T>
                        </div>
                        <div className='font-small pt-3'>
                          <T>
                            <a className='ad_footer_link' target="_blank" rel="noopener noreferrer" href="https://undervisning.aktiedysten.dk/premium-privat/">
                              Private / One-time Purchase
                            </a>
                          </T>
                        </div>
                      </Col>
                    </React.Fragment>
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>
      </React.Fragment>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/c/Footer.js